import React from 'react';
import ziyodulla from '../Images/Nargiza.png';


const Baxtiyor = () => {
    return (
        <div style={{color: 'black'}}>
            <div className='container text-start'>
                <div className='row'>
                    <div className='col-10'>
                        <h1 className='text-center'>МАЪЛУМОТНОМА</h1>
                        <h2 className='text-center'>Рахмонқулова Наргиза Ҳикматжон қизи</h2>
                        <p>2020 йил 2 сентябрдан:</p>
                        <p>Чилонзор туман 2-сон касб-ҳунар мактабининг - Топшириқларни бажарилишини назорат қилиш бўйича инспектор</p>
                    </div>   
                    <div className='col-2'>
                        <img src={ziyodulla} />
                    </div>    
                </div> 
                <div className='row'>
                    <div className='col'>
                        <p className='h5'>Туғилган йили:</p>
                        <p>03.11.1998</p>
                        <p className='h5'>Миллати:</p>
                        <p>ўзбек</p>
                        <p className='h5'>Маълумоти:</p>
                        <p>ўрта махсус</p>
                        <p className='h5'>Маълумоти бўйича мутахассислиги:</p>
                        <p className='h5'>Илмий даражаси:</p>
                        <p>йўқ</p>
                        <p className='h5'>Қайси чет тилларини билади:</p>
                        <p>рус тили</p>
                        <p className='h5'>Давлат мукофотлари билан тақдирланганми (қанақа):</p>
                        <p>йўқ</p>
                        <p className='h5'>Халқ депутатлари, республика, вилоят, шаҳар ва туман Кенгаши депутатими ёки бошқа
сайланадиган органларнинг аъзосими (тўлиқ кўрсатилиши лозим)	</p>
                        <p>йўқ</p>
                    </div>
                    <div className='col'>
                    <p className='h5'>Туғилган жойи:</p>
                        <p>Тошкент шаҳри</p>
                        <p className='h5'>Партиявийлиги:</p>
                        <p>йўқ</p>
                        <p className='h5'>Тамомлаган:</p>
                        <p>2017 й. Чилонзор педагогика коллежи (кундузги)</p>
                        <p>архившунослик ва иш юритувчи</p>
                        <p className='h5'>Илмий унвони:</p>
                        <p>йўқ</p>
                        <p className='h5'>Ҳарбий (махсус) унвони:</p>
                        <p>йўқ</p>
                    </div>
                </div>
                <p className='h3'>МЕҲНАТ ФАОЛИЯТИ</p>
                <p>2016-2016 йй. - АО "Электротармоқ қурилиш" да кадрлар бўлими инспектори</p>
                <p>2017-2019 йй. - Тошкент банк ҳисоб-кредит коллежининг - Кутубхоначиси</p>
                <p>2019-2020 йй. - Тошкент банк ҳисоб-кредит коллежининг - Котибаси</p>
                <p>2020-2020 йй. - Тошкент банк ҳисоб-кредит коллежининг - Кутубхоначи</p>
                <p>2020 й. -  ҳ.в.  - Чилонзор туман 2-сон касб-ҳунар мактабининг - Топшириқларни бажарилишини назорат қилиш бўйича инспектор</p>
                    <br />
                <p className='h2'>Малумотнома паспорт, диплом ва меҳнат дафтарчасига асосан тўғри ёзилган</p>
                <div className='row'>
                    <div className='col'>
                        <p className='h4'>КҲМ директори:</p>
                        <p className='h4'>Кадрлар бўйича инспектори:</p>
                    </div>
                    <div className='col'>
                        <p className='h4'>  Б.И.Тўйинов</p>
                        <p className='h4'>  Ш.А.Райимқулов  </p>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Baxtiyor;